import { Check, Minus } from "lucide-react";
import { Fragment } from "react";
import { TLB_COL, COMPETITORS, competitorRowSlug } from "../lib/competitorMatrix";

// TLB-vs-competitor comparison grid. TLB column is emphasised, competitor muted.
// Shared by the /vs-[competitor] pages and the Landing comparison section.

function Cell({ value, featured }) {
  if (value === true) {
    return (
      <Check
        className="w-4 h-4 mx-auto"
        style={{ color: featured ? "#7C5FB0" : "#10B981" }}
        data-testid="competitor-cell-yes"
      />
    );
  }
  if (value === false) {
    return <Minus className="w-4 h-4 mx-auto text-neutral-300" data-testid="competitor-cell-no" />;
  }
  return (
    <span
      className={`text-xs font-bold ${featured ? "text-[#5E4689]" : "text-neutral-500"}`}
      data-testid="competitor-cell-text"
    >
      {value}
    </span>
  );
}

export function CompetitorMatrix({ competitor = "liveplan", className = "" }) {
  const data = COMPETITORS[competitor] || COMPETITORS.liveplan;
  const cols = [TLB_COL, { key: "them", label: data.name, featured: false }];

  return (
    <section className={className} data-testid="competitor-matrix" data-competitor={competitor}>
      <div className="overflow-x-auto border border-neutral-900">
        <table className="w-full min-w-[560px] border-collapse text-left">
          <thead>
            <tr className="bg-neutral-900 text-white">
              <th className="py-3.5 px-4 text-[11px] uppercase tracking-[0.2em] font-bold">Feature</th>
              {cols.map((c) => (
                <th
                  key={c.key}
                  data-testid={`competitor-col-${c.key}`}
                  className={`py-3.5 px-4 text-center ${c.featured ? "bg-[#7C5FB0]" : ""}`}
                >
                  <div className="text-[11px] sm:text-xs uppercase tracking-[0.15em] font-black">
                    {c.label}
                  </div>
                  {c.featured && (
                    <div className="text-[9px] uppercase tracking-[0.2em] text-[#E9E0F6] font-bold mt-0.5">
                      You are here
                    </div>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.groups.map((group) => (
              <Fragment key={group.label}>
                <tr
                  className="bg-neutral-100"
                  data-testid={`competitor-group-${competitorRowSlug(group.label)}`}
                >
                  <td
                    colSpan={1 + cols.length}
                    className="py-2 px-4 text-[10px] uppercase tracking-[0.25em] font-bold text-neutral-600"
                  >
                    {group.label}
                  </td>
                </tr>
                {group.rows.map((row) => (
                  <tr
                    key={row.feature}
                    data-testid={`competitor-row-${competitorRowSlug(row.feature)}`}
                    className="border-t border-neutral-200"
                  >
                    <td className="py-2.5 px-4 text-sm text-neutral-800">{row.feature}</td>
                    {cols.map((c) => (
                      <td
                        key={c.key}
                        className={`py-2.5 px-4 text-center ${c.featured ? "bg-[#F5F2FB]" : ""}`}
                      >
                        <Cell value={c.key === "tlb" ? row.tlb : row.them} featured={c.featured} />
                      </td>
                    ))}
                  </tr>
                ))}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
